<template>
  <div class="cell example example4" id="example-4">
    <div
      class="alert alert-success alert-dismissible"
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      v-if="apiSuccessMessage!=null"
    >{{apiSuccessMessage}}</div>
    <div
      class="alert alert-danger alert-dismissible"
      :show="dismissCountDown"
      dismissible
      variant="danger"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      v-if="apiErrorMessage!=null"
    >{{ apiErrorMessage }}</div>
    <fieldset>
      <legend class="card-only" data-tid="elements_examples.form.pay_with_card">Add card detail</legend>
      <legend
        class="payment-request-available"
        data-tid="elements_examples.form.enter_card_manually"
      >Or enter card details</legend>
      <div class="container">
        <div ref="card" id="example4-card"></div>
        <button
          type="submit"
          @click="purchase"
          v-bind:class="{disabled:disableButton}"
          data-tid="elements_examples.form.donate_button"
        >{{addText}}</button>
      </div>
    </fieldset>
    <!-- We'll put the error messages in this element -->
    <div id="card-errors" class="error" role="alert"></div>
  </div>
</template>

<script>
const PUB_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
let stripe = Stripe(PUB_KEY),
  elements = stripe.elements(),
  card = undefined;

let elementStyle = {
  style: {
    iconStyle: "solid",
    base: {
      iconColor: "#6D5B97",
      color: "#32325D",
      fontWeight: 500,
      fontFamily: "Inter UI, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",

      "::placeholder": {
        color: "rgba(109, 91, 151, 0.5)"
      }
    },
    invalid: {
      color: "#e25950"
    }
  }
};

import { mapState } from "vuex";
import Vue from "vue";
import { ADD_PAYMENT_METHOD } from "../../store/payment/action.type";

export default {
  data() {
    return {
      apiErrorMessage: null,
      apiSuccessMessage: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      addText: "Add",
      disableButton: false,
      hasError: false
    };
  },
  mounted: function() {
    card = elements.create("card", elementStyle);
    card.mount(this.$refs.card);

    //card errors
    card.addEventListener("change", ({ error }) => {
      const displayError = document.getElementById("card-errors");
      if (error) {
        this.hasError = true;
        displayError.textContent = error.message;
      } else {
        this.hasError = false;
        displayError.textContent = "";
      }
    });
  },
  beforeDestroy() {
    card.destroy(this.$refs.card);
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    purchase: function() {
      //if no error
      if (this.hasError == false) {
        this.addText = "Please wait...";
        this.disableButton = true;

        let self = this;

        stripe
          .createPaymentMethod({
            type: "card",
            card: card
          })
          .then(function(result) {
            //if error
            if (result.error) {
              self.showAlertMessage = true;
              self.apiErrorMessage = result.error.message;
              self.apiSuccessMessage = null;
              self.addText = "Add";
              self.disableButton = false;
            }
            if (result.paymentMethod.id) {
              let body = {
                paymentMethod: result.paymentMethod.id
              };
              // add new payment method
              self.$store
                .dispatch(ADD_PAYMENT_METHOD, body)
                .then(response => {
                  if (response.status == 200) {
                    self.showAlertMessage = true;
                    self.apiSuccessMessage = null;
                    self.apiErrorMessage = null;

                    card.clear(self.$refs.card);
                    self.$emit("paymentMethodAdded", true);
                  } else {
                    self.showAlertMessage = true;
                    self.apiErrorMessage = response.data.message;
                    self.apiSuccessMessage = null;
                  }
                  self.addText = "Add";
                  self.disableButton = false;
                  self.showAlert();
                })
                .catch(error => {
                  self.addText = "Add";
                  self.disableButton = false;
                  self.showAlertMessage = true;
                  self.apiErrorMessage = error.message;
                  self.apiSuccessMessage = null;
                  self.showAlert();
                });
            }
          });
      }
    }
  }
};
</script>
<style>
.example.example4 {
  background-color: #f6f9fc;
}

.example.example4 * {
  font-family: Inter UI, Open Sans, Segoe UI, sans-serif;
  font-size: 16px;
  font-weight: 500;
}

.example.example4 form {
  max-width: 496px !important;
  padding: 0 15px;
}

.example.example4 form > * + * {
  margin-top: 20px;
}

.example.example4 .container {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 3px;
}

.example.example4 fieldset {
  border-style: none;
  padding: 5px;
  margin-left: -5px;
  margin-right: -5px;
  background: rgba(18, 91, 152, 0.05);
  border-radius: 8px;
}

.example.example4 fieldset legend {
  float: left;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #8898aa;
  padding: 3px 10px 7px;
}

.example.example4 .card-only {
  display: block;
  font-size: 1rem;
}
.example.example4 .payment-request-available {
  display: none;
}

.example.example4 fieldset legend + * {
  clear: both;
}

.example.example4 input,
.example.example4 button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
  color: #fff;
}

.example.example4 input:-webkit-autofill {
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.example.example4 #example4-card {
  padding: 10px;
  margin-bottom: 2px;
}

.example.example4 input {
  -webkit-animation: 1ms void-animation-out;
}

.example.example4 input::-webkit-input-placeholder {
  color: #9bacc8;
}

.example.example4 input::-moz-placeholder {
  color: #9bacc8;
}

.example.example4 input:-ms-input-placeholder {
  color: #9bacc8;
}

.example.example4 button {
  display: block;
  width: 100%;
  height: 37px;
  background-color: #fd3e75;
  border-radius: 2px;
  color: #fff;
  cursor: pointer;
}

.example.example4 button:active {
  background-color: #b76ac4;
}

.example.example4 .error svg .base {
  fill: #e25950;
}

.example.example4 .error svg .glyph {
  fill: #f6f9fc;
}

.example.example4 .error {
  color: #e25950;
}

.example.example4 .success .icon .border {
  stroke: #ffc7ee;
}

.example.example4 .success .icon .checkmark {
  stroke: #d782d9;
}

.example.example4 .success .title {
  color: #32325d;
}

.example.example4 .success {
  color: #8898aa;
}

.example.example4 .success .reset path {
  fill: #d782d9;
}
</style>